import { orderBy, merge } from 'lodash'

/****************************************
 *** apply methods for inhereted data ***
 ****************************************/

export function applyTabs(tabs) {
  for (let tabKey in tabs) {
    tabs[tabKey].key = tabKey
  }
  const curDashTabs = orderBy(tabs, ['order'])

  if (this.currentDash === 'core') {
    this.tabs = curDashTabs
  } else {
    const selectedTemplatesTabs = []
    for (let template of this.selectedTemplates) {
      if (!this.templateDashboardsList.includes(template)) {
        console.error(
          `[Inherit Template] - template "${template}" doesn't exist in template list`
        )
        continue
      }

      for (let tabKey in this.inheritedData[template].tabs) {
        this.inheritedData[template].tabs[tabKey].key = tabKey
        this.inheritedData[template].tabs[tabKey].inherited = true
        this.inheritedData[template].tabs[tabKey].template = template
      }
      selectedTemplatesTabs.push(
        orderBy(this.inheritedData[template].tabs, ['order'])
      )
    }

    for (let tabKey in this.inheritedData.core.tabs) {
      this.inheritedData.core.tabs[tabKey].key = tabKey
      this.inheritedData.core.tabs[tabKey].inherited = true
      this.inheritedData.core.tabs[tabKey].template = 'core'
    }
    const coreTabs = orderBy(this.inheritedData.core.tabs, ['order'])

    this.tabs = [].concat(...selectedTemplatesTabs, coreTabs, curDashTabs)
  }
}

export function applySubTabs(subTabs) {
  if (this.currentDash === 'core') {
    this.subTabs = subTabs || {}
  } else {
    // templates widgets data
    let selectedTemplatesSubTabs = {}
    for (let template of this.selectedTemplates) {
      if (!this.templateDashboardsList.includes(template)) {
        console.error(
          `[Inherit Template] - template "${template}" doesn't exist in template list`
        )
        continue
      }

      for (let subTabKey in this.inheritedData[template].tabs) {
        if (!this.inheritedData[template].subTabs) break
        if (!this.inheritedData[template].subTabs[subTabKey]) continue

        this.inheritedData[template].subTabs[subTabKey].inherited = true
        this.inheritedData[template].subTabs[subTabKey].template = template
      }

      selectedTemplatesSubTabs = merge(
        selectedTemplatesSubTabs,
        this.inheritedData[template].subTabs
      )
    }

    for (let subTabKey in this.inheritedData.core.subTabs) {
      this.inheritedData.core.subTabs[subTabKey].inherited = true
      this.inheritedData.core.subTabs[subTabKey].template = 'core'
    }

    this.subTabs = merge(
      selectedTemplatesSubTabs,
      this.inheritedData['core'].subTabs,
      subTabs
    )
  }
}

export function applyWidgets(widgets) {
  if (this.currentDash === 'core') {
    this.widgets = widgets
  } else {
    // templates widgets
    let selectedTemplatesWidgets = {}
    for (let template of this.selectedTemplates) {
      if (!this.templateDashboardsList.includes(template)) {
        console.error(
          `[Inherit Template] - template "${template}" doesn't exist in template list`
        )
        continue
      }

      selectedTemplatesWidgets = merge(
        selectedTemplatesWidgets,
        this.inheritedData[template].widgets
      )
    }

    for (let widgetKey in selectedTemplatesWidgets) {
      selectedTemplatesWidgets[widgetKey].inherited = true
    }

    for (let widgetKey in this.inheritedData['core'].widgets || {}) {
      this.inheritedData['core'].widgets[widgetKey].inherited = true
    }

    // core widgets

    this.widgets = merge(
      selectedTemplatesWidgets,
      this.inheritedData['core'].widgets,
      widgets
    )
  }
}

export function applyWidgetsData(widgetsData) {
  if (this.currentDash === 'core') {
    this.widgetsData = widgetsData
  } else {
    // templates widgets data
    let selectedTemplatesWidgetsData = {}
    for (let template of this.selectedTemplates) {
      if (!this.templateDashboardsList.includes(template)) {
        console.error(
          `[Inherit Template] - template "${template}" doesn't exist in template list`
        )
        continue
      }

      if (this.$markInheritedColumns)
        this.$markInheritedColumns(this.inheritedData[template].widgetsData)
      if (this.$changeFormDesignerFormat)
        this.$changeFormDesignerFormat(
          this.inheritedData[template].widgetsData,
          'object'
        )

      selectedTemplatesWidgetsData = merge(
        selectedTemplatesWidgetsData,
        this.inheritedData[template].widgetsData
      )
    }

    if (this.$markInheritedColumns)
      this.$markInheritedColumns(this.inheritedData.core.widgetsData)
    if (this.$changeFormDesignerFormat)
      this.$changeFormDesignerFormat(
        this.inheritedData.core.widgetsData,
        'object'
      )
    if (this.$changeFormDesignerFormat)
      this.$changeFormDesignerFormat(widgetsData, 'object')

    const bondedInheritedData = merge(
      selectedTemplatesWidgetsData,
      this.inheritedData.core.widgetsData
    )

    if (this.$populateFormDesigner)
      this.$populateFormDesigner(widgetsData, bondedInheritedData)
    if (this.$populateDataGridMeta)
      this.$populateDataGridMeta(widgetsData, bondedInheritedData)

    if (this.$changeFormDesignerFormat)
      this.$changeFormDesignerFormat(widgetsData, 'json')
    if (this.$changeFormDesignerFormat)
      this.$changeFormDesignerFormat(bondedInheritedData, 'json')

    this.widgetsData = merge(bondedInheritedData, widgetsData)
  }

  this.$store.commit('extractDashboardSheets', this.widgetsData)
  this.$store.commit('dataGrid_setOptions', this.widgetsData.dataGrid)
  if (this.cacheDashboardSheets) this.cacheDashboardSheets()
}

export function applyCustomCode(customCode) {
  if (this.currentDash === 'core') {
    this.customCode = customCode || {}
  } else {
    // templates widgets data
    let selectedTemplatesCustomCode = {}
    for (let template of this.selectedTemplates) {
      if (!this.templateDashboardsList.includes(template)) {
        console.error(
          `[Inherit Template] - template "${template}" doesn't exist in template list`
        )
        continue
      }

      selectedTemplatesCustomCode = merge(
        selectedTemplatesCustomCode,
        this.inheritedData[template].customCode
      )
    }

    this.customCode = merge(
      selectedTemplatesCustomCode,
      this.inheritedData['core'].customCode,
      customCode
    )
  }
}

export function applyComponents(components) {
  // templates widgets data
  let selectedTemplatesComponents = {}
  for (let template of this.selectedTemplates) {
    if (!this.templateDashboardsList.includes(template)) {
      console.error(
        `[Inherit Template] - template "${template}" doesn't exist in template list`
      )
      continue
    }

    selectedTemplatesComponents = merge(
      selectedTemplatesComponents,
      this.inheritedData[template].components
    )
  }

  this.$store.commit(
    'setCustomComponents',
    merge(
      selectedTemplatesComponents,
      this.inheritedData.core.components || {},
      components
    )
  )
}
